
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductReport } from '@/interfaces/ProductReport';

@Component({
    name: 'AccountRecordsAdded',
})

export default class AccountAddRecords extends Vue {
    @Prop({
        required: true,
    }) protected isAccountRecordsAdded!: boolean;
    @Prop({
        required: true,
    }) protected noDuplicatesIds!: ProductReport[];
    @Prop({
        required: true,
    }) protected duplicates!: ProductReport[];

    protected closeDialog() {
        this.$emit('closeDialog', 'message');
    }

}
